<template>
  <b-row>
    <b-col sm="3">
      <strong>Description</strong>
      <p>Enter the opportunity description here.</p>
    </b-col>
    <b-col sm="9">
      <b-form class="form-horizontal">
        <b-form-group label="Description" label-class="control-label opportunity-form-label">
          <vue-editor v-model="description" id="descriptionEditor"></vue-editor>
        </b-form-group>

        <slot name="buttons"></slot>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import { VueEditor } from "vue2-editor";

var htmlEncode = require("js-htmlencode").htmlEncode;
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {};
  },

  components: {
    VueEditor
  },

  props: {
    opportunity: {
      type: Object
    }
  },

  watch: {
    opportunity: function() {
      if (this.opportunity.description) {
        this.description = htmlDecode(this.opportunity.description);
      }
    }
  },

  computed: {
    description: {
      get() {
        var returnValue = this.$store.state.opportunityForm.opportunity
          .description;
        if (returnValue) {
          returnValue = htmlDecode(returnValue);
        }
        return returnValue;
      },
      set(value) {
        var encodedValue = "";
        if (value) {
          encodedValue = htmlEncode(value);
        }
        this.$store.commit("updateDescription", encodedValue);
      }
    }
  }
};
</script>

<style scoped>
</style>
